// src/services/geografia.service.js
import api from './api';

class GeografiaService {
  getDepartamentos() {
    return api.get('/geografia/departamentos');
  }

  getMunicipiosByDepartamento(departamentoId) {
    return api.get(`/geografia/departamentos/${departamentoId}/municipios`);
  }

  getAllMunicipios() {
    return api.get('/geografia/municipios');
  }
}

export default new GeografiaService();